/**
 * ============================================================================
 *  Banner 0 A/B por visita
 * ----------------------------------------------------------------------------
 *  Identifica cada visita do usuário e alterna a imagem do PRIMEIRO banner
 *  (.banner.flickity-cell de índice 0) entre duas variantes (A e B).
 *  Também troca o link (<a>) e o alt, se você definir.
 *
 *  Não depende do Flickity: apenas reescreve o <picture> da célula 0.
 *  Cole antes de </body> ou carregue como arquivo externo.
 * ============================================================================
 */
(function () {
  'use strict';
   // ===================== CONFIGURAÇÃO =====================

  // As duas imagens que vão se alternar no banner 0.
  // Coloque as URLs de desktop e mobile de cada variante.
  // (A variante A abaixo já está com a imagem EMBER atual como exemplo.)
  const VARIANTS = [
    {
      name: 'A',
      desktop: 'https://www.invictus.com.br/cdn/shop/files/DESKTOP-EMBER.jpg?v=1784914101',
      mobile:  'https://www.invictus.com.br/cdn/shop/files/MOBILE-EMBER.jpg?v=1784914101',
      link:    '/products/jaqueta-ember-preta',
      alt:     '',
    },
    {
      name: 'B',
      desktop: 'https://cdn.shopify.com/s/files/1/0918/0046/9822/files/DESKTOP-SQUARE.jpg?v=1785327021',
      mobile:  'https://cdn.shopify.com/s/files/1/0918/0046/9822/files/MOBILE-SQUARE.jpg?v=1785327021',
      link:    '/collections/jaquetas-square',
      alt:     '',
    },
  ];

const CONFIG = {
    // Como contar uma "visita":
    //   'session'  -> +1 a cada nova sessão (aba/navegador reaberto). Recomendado.
    //   'pageload' -> +1 a cada carregamento de página.
    //   'daily'    -> no máximo +1 por dia.
    visitMode: 'pageload',
 
    // Chaves de armazenamento
    storageKey: 'inv_visit_count',
    sessionKey: 'inv_session_active',
    dayKey: 'inv_last_visit_day',
 
    // Seletores
    sliderSelector: 'slideshow-hero',
    cellSelector: '.banner.flickity-cell',
    bannerIndex: 0, // qual célula alternar (0 = primeira)
 
    // Quantas visitas cada imagem fica no ar antes de trocar.
    // 5 -> visitas 1..5 = A, 6..10 = B, 11..15 = A, ...
    visitsPerVariant: 5,
 
    // Larguras usadas no srcset (iguais às do tema)
    desktopWidths: [300,400,500,600,700,800,900,1000,1200,1400,1600,1800,2000],
    mobileWidths:  [400,600,800,1000],
    fallbackWidth: 2048, // usado no atributo src
 
    // Evita "piscar" a imagem A antes de trocar para a B:
    // esconde a célula até aplicar a variante.
    preventFlash: true,
 
    // Abrir o link do banner em nova aba?
    openInNewTab: false,
 
    debug: false,
  };
  // ========================================================
 
  function log() {
    if (CONFIG.debug) console.log('[banner-0-ab]', ...arguments);
  }
 
  /**
   * Retorna o número da visita atual, incrementando conforme o visitMode.
   */
  function getVisitCount() {
    let count = parseInt(localStorage.getItem(CONFIG.storageKey) || '0', 10);
    if (isNaN(count)) count = 0;
    let inc = false;
 
    switch (CONFIG.visitMode) {
      case 'pageload':
        inc = true;
        break;
      case 'daily': {
        const today = new Date().toISOString().slice(0, 10);
        if (localStorage.getItem(CONFIG.dayKey) !== today) {
          localStorage.setItem(CONFIG.dayKey, today);
          inc = true;
        }
        break;
      }
      case 'session':
      default:
        if (!sessionStorage.getItem(CONFIG.sessionKey)) {
          sessionStorage.setItem(CONFIG.sessionKey, '1');
          inc = true;
        }
        break;
    }
 
    if (inc) {
      count += 1;
      localStorage.setItem(CONFIG.storageKey, String(count));
    }
    log('visita nº', count, '(modo:', CONFIG.visitMode + ')');
    return count;
  }
 
  /** Monta um srcset no padrão da Shopify (?...&width=N Nw). */
  function buildSrcset(url, widths) {
    const sep = url.indexOf('?') !== -1 ? '&' : '?';
    return widths.map(function (w) {
      return url + sep + 'width=' + w + ' ' + w + 'w';
    }).join(', ');
  }
 
  /** Adiciona um parâmetro de largura à URL do src de fallback. */
  function withWidth(url, w) {
    const sep = url.indexOf('?') !== -1 ? '&' : '?';
    return url + sep + 'width=' + w;
  }
 
  /** Aplica uma variante na célula de banner informada. */
  function applyVariant(cell, variant) {
    const picture = cell.querySelector('picture');
    if (!picture) { log('sem <picture> na célula'); return false; }
 
    const img = picture.querySelector('img');
    const source = picture.querySelector('source'); // versão mobile
    const link = cell.querySelector('a[href]');
 
    if (source && variant.mobile) {
      source.setAttribute('srcset', buildSrcset(variant.mobile, CONFIG.mobileWidths));
    }
    if (img && variant.desktop) {
      img.setAttribute('srcset', buildSrcset(variant.desktop, CONFIG.desktopWidths));
      img.setAttribute('src', withWidth(variant.desktop, CONFIG.fallbackWidth));
      if (typeof variant.alt === 'string') img.setAttribute('alt', variant.alt);
    }
    if (link && variant.link) {
      link.setAttribute('href', variant.link);
      // torna o link realmente clicável mesmo quando o slide não está ativo
      link.removeAttribute('aria-hidden');
      link.style.pointerEvents = 'auto';
      if (CONFIG.openInNewTab) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener');
      }
      attachClickFallback(cell, variant.link);
    }
 
    log('variante aplicada:', variant.name, '-> link', variant.link);
    return true;
  }
 
  /**
   * Reforço de clique: em carrossel Flickity o clique pode ser "engolido"
   * como arraste. Aqui navegamos manualmente quando for um clique real
   * (sem arraste) e o alvo não for outro link/botão.
   */
  function attachClickFallback(cell, url) {
    if (!url || cell.__invClickBound) return;
    cell.__invClickBound = true;
 
    let downX = 0, downY = 0, moved = false;
 
    cell.addEventListener('pointerdown', function (e) {
      downX = e.clientX; downY = e.clientY; moved = false;
    }, true);
 
    cell.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8) {
        moved = true; // passou de arraste
      }
    }, true);
 
    cell.addEventListener('click', function (e) {
      if (moved) return;                       // foi arraste, ignora
      // respeita cliques em outros links/botões reais dentro da célula
      const realCtrl = e.target.closest('a[href], button');
      if (realCtrl && realCtrl.getAttribute('href') &&
          realCtrl.getAttribute('href') !== url) return;
      // deixa o navegador tratar ctrl/cmd/click-do-meio (nova aba)
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.button === 1) return;
 
      if (CONFIG.openInNewTab) {
        window.open(url, '_blank', 'noopener');
      } else {
        window.location.href = url;
      }
    });
  }
 
  /** Espera um elemento aparecer no DOM (polling + timeout). */
  function waitForCell() {
    return new Promise(function (resolve) {
      const start = Date.now();
      (function loop() {
        const slider = document.querySelector(CONFIG.sliderSelector);
        const cell = slider &&
          slider.querySelectorAll(CONFIG.cellSelector)[CONFIG.bannerIndex];
        if (cell) return resolve(cell);
        if (Date.now() - start >= 8000) return resolve(null);
        requestAnimationFrame(loop);
      })();
    });
  }
 
  function init() {
    // 1) SEMPRE conta a visita, independente de o banner existir.
    const visitCount = getVisitCount();
    const per = Math.max(1, CONFIG.visitsPerVariant | 0);
    const block = Math.floor((visitCount - 1) / per); // muda a cada "per" visitas
    const variant = VARIANTS[block % VARIANTS.length];
    log('bloco', block, '-> variante', variant.name);
 
    // 2) Aguarda o carrossel para aplicar a imagem.
    waitForCell().then(function (cell) {
      if (!cell) { log('célula não encontrada (timeout)'); return; }
 
      let prevVisibility;
      if (CONFIG.preventFlash) {
        prevVisibility = cell.style.visibility;
        cell.style.visibility = 'hidden';
      }
 
      applyVariant(cell, variant);
 
      if (CONFIG.preventFlash) {
        requestAnimationFrame(function () {
          cell.style.visibility = prevVisibility || '';
        });
      }
    });
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();